import { useContext } from "react";
import { Paragraph } from "capitalrx-components-2.0";
import { formatPriceDisplay } from "capitalrx-utilities";
import cn from "classnames";
import GetTheApp from "../GetTheApp/GetTheApp";
import styles from "./PharmacyDetailsPriceCard.module.scss";
import { ThemeSelectorContext } from "@/context/index";

interface Props {
  price: string;
}

const PharmacyDetailsPriceCard = (props: Props): JSX.Element => {
  const { price } = props;
  const { client } = useContext(ThemeSelectorContext);

  const priceDisplayClassname = cn(
    styles.PharmacyDetailsPriceCardPrice,
    { [styles.PharmacyDetailsPriceCardWhitelabel]: !!client },
  );

  const priceHeaderClassname = cn(
    styles.PharmacyDetailsPriceCardHeader,
    { [styles.PharmacyDetailsPriceCardWhitelabel]: !!client },
  );

  const renderPrice = () => {
    let priceDisplay = "";
    if (isNaN(Number(price))) {
      priceDisplay = "Check at Pharmacy for Price.";

      return (
        <Paragraph className={priceDisplayClassname} testId="pharmacy-details-price">
          {priceDisplay}
        </Paragraph>
      );
    } else {
      priceDisplay = formatPriceDisplay(Number(price));
      return (
        <>
          <Paragraph className={priceHeaderClassname}>Estimated Advantage Price:</Paragraph>
          <Paragraph className={priceDisplayClassname} testId="pharmacy-details-price">
            {priceDisplay}
          </Paragraph>
        </>
      );
    }
  };

  return (
    <div className={styles.PharmacyDetailsPriceCard} data-testid="pharmacy-details-price-card">
      {renderPrice()}
      <hr />
      {/* <Paragraph className={styles.PharmacyDetailsPriceCardCTA}>
        Download the <strong>FREE</strong> Advantage Card through our app and present it to the pharmacy when you fill your prescription.
  </Paragraph> */}
      <GetTheApp />
    </div>
  );
};

export default PharmacyDetailsPriceCard;
